export default __webpack_public_path__ + "static/media/chevron-left.4038dd38.svg";